import React, { useContext } from 'react';
import { VideoStudiosContext, IVideoStudiosContext } from '../../../videoStudiosState/videoStudiosContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString } = useContext<IVideoStudiosContext>(VideoStudiosContext);

	return <SearchField onChangeSelectSearchString={changeSearchString} searchString={searchString} delay={800} />;
};

export default Search;
